import BaseView from './BaseView';

import HomeIntroVideo  from '../../components/HomeIntroVideo';
import EventCarousel from '../../modules/EventCarousel';
import InteractiveMap from '../../modules/InteractiveMap';
import HomeFooter from '../../components/HomeFooter';
import HomeScrollAnimations from '../../components/HomeScrollAnimations';

let view = null;

class Home extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.container.querySelectorAll('[data-event-carousel]').forEach((el) => {
			this.modules.push(new EventCarousel(el));
		});

		this.container.querySelectorAll('[data-home-footer]').forEach((el) => {
			this.modules.push(new HomeFooter(el, this));
		});

		this.modules.push(new HomeScrollAnimations(this.container));

		this.container.querySelectorAll('[data-interactive-map]').forEach((el) => {
			this.modules.push(new InteractiveMap(el));
		});

	}

	destroy() {
		super.destroy();
	}

}

export default {
	namespace: 'home',
	beforeEnter: ({ current, next, trigger }) => {
		const homeIntroVideosElm = next.container.querySelector('[data-home-intro-videos]');
		if(homeIntroVideosElm) {
			if(trigger=='barba') {
				new HomeIntroVideo(homeIntroVideosElm);
			} else {
				homeIntroVideosElm.remove();
			}
		}

		view = new Home(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
